import { render, staticRenderFns } from "./CAFormGlobal.vue?vue&type=template&id=78599382&"
import script from "./CAFormGlobal.vue?vue&type=script&lang=js&"
export * from "./CAFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports